'use client';
import { useEffect, useState } from 'react';

declare global {
  interface Window {
    OneTrust?: {
      IsAlertBoxClosed: () => boolean;
    };
  }
}

const COOKIE_BANNER_ID = 'onetrust-banner-sdk';

export function useCookieBannerHeight(): number {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const bannerResizeObserver = new ResizeObserver(([entry]) =>
      setHeight(entry?.borderBoxSize[0]?.blockSize ?? 0)
    );

    const observeBanner = () => {
      const banner = document.getElementById(COOKIE_BANNER_ID);
      if (banner) bannerResizeObserver.observe(banner);
      return !!banner;
    };

    // OneTrust injects the banner asynchronously, and not at all for visitors who have already chosen.
    const bannerInsertionObserver = new MutationObserver(() => {
      if (observeBanner()) bannerInsertionObserver.disconnect();
    });

    const stopWaitingIfDismissed = () => {
      if (window.OneTrust?.IsAlertBoxClosed()) {
        bannerInsertionObserver.disconnect();
      }
    };

    if (!observeBanner()) {
      bannerInsertionObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
      window.addEventListener('OneTrustGroupsUpdated', stopWaitingIfDismissed);
    }

    return () => {
      bannerInsertionObserver.disconnect();
      bannerResizeObserver.disconnect();
      window.removeEventListener(
        'OneTrustGroupsUpdated',
        stopWaitingIfDismissed
      );
    };
  }, []);

  return height;
}
